import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasUnsavedChanges: false,
  isEdit: false,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setHasUnsavedChanges: (state, action) => {
      state.hasUnsavedChanges = action.payload;
    },
    resetFormState: (state) => {
      state.hasUnsavedChanges = false;
    },
    setIsEdit: (state, action) => {
      //   console.log('setIsEdit called with:', action.payload);
      state.isEdit = action.payload;
    },
  },
});

export const { setHasUnsavedChanges, resetFormState, setIsEdit } = formSlice.actions;

export default formSlice.reducer;
